<template>
  <transition name="fade-in">
    <div id="assist_poster" class="animatedd fadeIn" @click.self="close" ref="main">
      <div v-if="!poster" class="empty">
        <InlineLoading />
      </div>
      <div ref="poster" v-else class="container animatedd slideInUp">
        <img :src="poster" />
        <h1>
          <i class="anyteachicon anyteach-arrow-up" />
          <span>长按上方图片保存</span>
        </h1>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "Poster",
  props: ["poster"],
  methods: {
    close() {
      return this.$emit("dismiss")
    },
  },
}
</script>

<style lang="scss" scoped>
@import "../style.scss";

$blackBgd: rgba(0, 0, 0, 0.8);

.fade-in-enter-active {
  transition: all 0.3s ease;
}
.fade-in-leave-active {
  transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
}
.fade-in-enter,
.fade-in-leave-to {
  opacity: 0;
  background: none;
  transform: translateY(100%);
}

.animated {
  animation-delay: 0s !important;
  animation-duration: 0.5s !important;
}
#assist_poster {
  position: fixed;
  top: 0;
  left: 0;
  overflow: scroll;
  width: 100%;
  height: 100vh;
  z-index: 4;
  background: $blackBgd;
  display: flex;
  align-items: center;
  justify-content: center;
}

.empty {
  height: 80vh;
  background: none;
}
.empty,
.container {
  width: 70%;
}
.container {
  text-align: center;
  img {
    width: 100%;
  }
  h1 {
    color: white;
    font-size: 0.9rem;
    padding: 5px 0 0 0;
    i {
      font-size: inherit;
      padding: 0 5px 0 0;
      animation: 1.2s ease-out infinite hover;
      -webkit-animation: 1.2s ease-out infinite hover;
      -moz-animation: 1.2s ease-out infinite hover;
      display: inline-block;
    }
    @keyframes hover {
      50% {
        transform: translateY(-4px);
      }
    }
  }
}
</style>
